import {Pressable, Text, StyleSheet, View} from "react-native";
import React, {useEffect, useState} from "react";
import {FontAwesome} from "@expo/vector-icons";
import {useNavigation, useTheme} from "@react-navigation/native";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {AsyncDispatch} from "../function/functions";

export default function BalanceSelectButton(props) {
    const {  title = 'Balance', id, color, task } = props;
    const navigation = useNavigation();
    const tasks = useSelector(state => state.tasks);
    const taskData = tasks[task];

    const dispatch = useDispatch();
    let taskBalance = taskData.balance ? [...taskData.balance] : [];
    const theme = useTheme();
    const {t, i18n} = useTranslation();

    const [check, setCheck] = useState(taskBalance.includes(id));

    useEffect(() => {
        taskBalance = taskData.balance ? [...taskData.balance] : [];
    }, [check, tasks])

    const styles = StyleSheet.create({
        button: {
            position:'relative',
            display: 'flex',
            flexDirection:'row',
            width: '100%',
            height: 48,
            backgroundColor: theme.colors.scheme[4],
            fontFamily: 'Roboto-Regular',
            fontSize: 16,
            borderWidth: 2,
            borderColor:theme.colors.scheme[6],
            borderRadius: 27,
            justifyContent:'flex-start',
            alignItems:'center'
        },
        text: {
            fontFamily:'Roboto-Regular',
            color: theme.colors.scheme[2],
            fontSize:12
        },
        colorCircle: {
            display:'flex',
            flexDirection:'row',
            alignItems:'center',
            justifyContent:'center',
            width:32,
            height:32,
            borderRadius:32,
            backgroundColor: (check) ? color : theme.colors.scheme[4],
            borderWidth:2,
            borderColor:theme.colors.scheme[6],
            marginHorizontal:8
        },
        icon: {
            fontSize:16,
            color: (check) ? theme.colors.scheme[4] : theme.colors.scheme[3]
        }
    });

    return (
        <Pressable style={(({ pressed }) => [
            { opacity: pressed ? 0.5 : 1.0 }, styles.button
        ])} onPress={() => {
            if (check) {
                let index = taskBalance.indexOf(id)
                if (index !== -1) {
                    taskBalance.splice(index, 1);
                }
            }
            else taskBalance.push(id)

            AsyncDispatch(dispatch, "EDIT_TASK", {id: task, data: {balance: taskBalance}}).then(() => {
                dispatch({type: 'SAVE_TASK', payload: []});
                setCheck(!check);
            })
        }}>
            <View style={styles.colorCircle}></View><Text style={styles.text}>{t('balance.option.'+title)}</Text>
        </Pressable>
    );
}